"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Text_1 = require("./Text");
var theme_1 = require("./theme");
var UIComponents_1 = require("./UIComponents");
/**
 * A banner used to present contextual information within the layout of a given page.
 * @param {string=} label - The main title of the banner
 * @param {string=} description - The text content of the banner
 * @param {Object=} icon - Icon used next to the label
 * @param {string=} action - Action button text
 * @param {function=} onClick - Action button handler
 * @param {boolean=} [fullWidth=false] - Whether to display a full width banner
 * @param {boolean=} [maintainBorderRadius=false] - Whether to display the border on a fill width banner
 * @param {string=} background - Custom background color
 * @param {string=} [priority=low] - Can be low or high
 * @param {string=} [type=neutral] - Can be neutral, error, warning, or info
 */
var Banner = function (_a) {
    var label = _a.label, description = _a.description, background = _a.background, _b = _a.priority, priority = _b === void 0 ? "low" : _b, _c = _a.type, type = _c === void 0 ? "neutral" : _c, icon = _a.icon, action = _a.action, onClick = _a.onClick, props = __rest(_a, ["label", "description", "background", "priority", "type", "icon", "action", "onClick"]);
    var Icon = icon;
    var color = type === "error" && priority === "high"
        ? theme_1.theme.colors.white
        : type === "info"
            ? theme_1.theme.colors.gold900
            : theme_1.theme.colors.gray900;
    return (react_1.default.createElement(BannerWrapper, __assign({}, props, { type: type, background: background, priority: priority }),
        action ? (react_1.default.createElement(Text_1.Text, { variant: "uiSmall600", onClick: onClick, style: { cursor: "pointer", margin: "auto 0" }, color: color }, action)) : Icon != undefined ? (react_1.default.createElement(Icon, { width: 16, height: 16, onClick: onClick, stroke: color, style: {
                cursor: "pointer",
                marginRight: props.fullWidth ? 0 : 8,
                marginLeft: props.fullWidth ? "auto" : 0,
                marginTop: description ? 0 : 2,
            } })) : (react_1.default.createElement("div", null)),
        react_1.default.createElement("div", null,
            label && (react_1.default.createElement(Text_1.Text, { variant: description ? "uiSmall500" : "paragraphMedium", color: color }, label)),
            description && (react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", mt: "xxsmall", color: color }, description)))));
};
exports.Banner = Banner;
var BannerWrapper = (0, styled_1.default)(UIComponents_1.ui.Wrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  padding: ", " 16px;\n  box-sizing: border-box;\n  ", "\n  background-color: ", ";\n  border-radius: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n"], ["\n  display: flex;\n\n  padding: ", " 16px;\n  box-sizing: border-box;\n  ", "\n  background-color: ", ";\n  border-radius: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n"])), function (props) { return (props.fullWidth ? "12px" : "14px"); }, function (props) { return props.fullWidth && "width: 100%;"; }, function (_a) {
    var type = _a.type, priority = _a.priority, background = _a.background;
    if (background)
        return background;
    switch (type) {
        case "error":
            return priority == "high" ? theme_1.theme.colors.red700 : theme_1.theme.colors.red000;
        case "info":
            return priority == "high" ? theme_1.theme.colors.gold400 : theme_1.theme.colors.gold100;
        case "warning":
            return theme_1.theme.colors.yellow500;
        case "neutral":
        default:
            return theme_1.theme.colors.gray300;
    }
}, function (props) {
    return props.fullWidth && !props.maintainBorderRadius ? "0px" : "8px";
}, function (props) { return (props.fullWidth ? "row-reverse" : "row"); }, function (props) { return (props.fullWidth ? "space-between" : "start"); });
var templateObject_1;
